import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Input} from 'components/danangtrade-forms/common';
import {SingleImageUploader} from 'components/uploader';
import CONFIG from 'base/constants/config';
// import style from './_HighlightBusinessForm.scss';
import {ShowIf} from 'components/utils';
import {toastr} from 'react-redux-toastr';
import {HighlightBusinesses} from 'base/api';

class HighlightBusinessForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formAddHighlightBusiness'] = [];
  }

  state = {
    link: '',
    priority: '',
    banner: null,
    dataImage: null
  }

  static defaultProps = {
    validators: {}
  }

  bindData(data) {
    const {link, priority, banner} = data;

    this.setState({link, priority, banner});
  }

  componentDidMount() {
    if (this.props.data) {
      this.bindData(this.props.data)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.state.data) {
      this.bindData(nextProps.data);
    }
  }

  submitForm(e) {
    e.preventDefault();

    let params = {};

    if (this.validateSubmitForm()) {
      let { ...data } = this.state;
      delete data.dataImage;
      if (this.props.data && typeof this.props.data.id != "undefined") {
        params = {id: this.props.data.id};
      }

      return this.props.dispatch(this.props.fnSubmit(params, {
        data
      })).then(response => {
        if (typeof this.props.cb == 'function') {
          this.props.cb(response);
        }

        return Promise.resolve(response)
      }).catch(err => {
        Promise.reject(err);
      });

    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    }

    return false;
  }

  validateSubmitForm() {
    if (!this.state.banner) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn doanh nghiệp nổi bật');
      return false;
    }
    let pass = true;
    this.props.validators['formAddHighlightBusiness'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    return pass;
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  onUploadComplete(image, dataImage) {
    this.setState({
      banner: image.name,
      dataImage
    });
  }

  onRemoveImage(image) {
    this.setState({banner: null, dataImage: null})
  }

  render() {
    return (
      <div className="register-business-box home-banner-form">
        <form onSubmit={this.submitForm.bind(this)}>
          <SingleImageUploader
            fnUpload={HighlightBusinesses.actions.upload.request}
            onUploadComplete={this.onUploadComplete.bind(this)}
            image={this.state.banner}
            // dataImage={this.state.dataImage}
            type="HIGHLIGHT_BUSINESS"
            onRemoveImage={this.onRemoveImage.bind(this)}
          />
          <div className="register-box-body">
            <Input type="text" placeholder="Link doanh nghiệp nổi bật..."
              className='has-feedback fg-custom'
              iconClassName='fa-link'
              value={this.state.link}
              required={true}
              onChange={this.onChange.bind(this, 'link')}
              bindValidator={this} channel="formAddHighlightBusiness"
              errorMessage="Link doanh nghiệp nổi bật không được để trống"
            />
            <Input type="proority" placeholder="Độ ưu tiên của doanh nghiệp nổi bật..."
              className='has-feedback fg-custom'
              iconClassName='fa-sort-numeric-asc'
              value={this.state.priority}
              onChange={this.onChange.bind(this, 'priority')}
              required={true}
              bindValidator={this} channel="formAddHighlightBusiness"
              errorMessage="Bạn vui lòng cung cấp độ ưu tiên"
            />
            <div>
              <ShowIf condition={this.props.data}>
                <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">CẬP NHẬT</button>
              </ShowIf>
              <ShowIf condition={!this.props.data}>
                <button type="submit" className="btn btn-primary btn-block btn-flat btn-submit text-btn">THÊM</button>
              </ShowIf>
            </div>
          </div>
        </form>
    </div>
    );
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(HighlightBusinessForm));



// WEBPACK FOOTER //
// ./components/highlight-businesses/HighlightBusinessForm.jsx